module.exports = __webpack_public_path__ + "img/log.2b2ea6d0.svg";